import Card from '../../components/Card'

const Project = ({ project, onExpand }) => {
  return (
    <Card className="portfolio__project" onClick={onExpand}>
      <div className="portfolio__project-image">
        <img src={project.image} alt={project.title} loading="lazy" />
      </div>
      <h4>{project.title}</h4>
      <p>{project.desc}</p>
      <div className="portfolio__project-cta">
        <button className="btn sm primary portfolio__project-details-btn">View Details</button>
        <a
          href={project.demo}
          className="btn sm light"
          target="_blank"
          rel="noopener noreferrer"
          onClick={e => e.stopPropagation()}
        >
          Visit
        </a>
      </div>
    </Card>
  )
}

export default Project